<template>
    <svg
        id="icon_pause"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="18"
        viewBox="0 0 12 18"
    >
        <rect
            id="Rectangle_56"
            data-name="Rectangle 56"
            width="4"
            height="18"
            rx="2"
            fill="#854b97"
        />
        <rect
            id="Rectangle_57"
            data-name="Rectangle 57"
            width="4"
            height="18"
            rx="2"
            transform="translate(8)"
            fill="#854b97"
        />
    </svg>
</template>
